// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"b17d1ade","643":"b7208042","667":"81582698","907":"abe63896"}[chunkId] + ".chunk.js";
};